import React, { Component } from "react";
import { getReferences } from "../../services/vu";
import {
  findCountriesByDescription,
  getCountryByCountryCodeOrDescription,
} from "../../helpers/form";
import CountryCode from "../../enums/Country";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";

export default class Country extends Component {
  constructor(props) {
    super(props);

    this.state = {
      countries: [],
      searchText: "",
    };
  }

  componentDidMount() {
    getReferences().then(({ soneCountryCodeList = [] }) => {
      const country = soneCountryCodeList.find((country) => {
        return country.countryCode === `${this.props.value}`;
      });

      this.setState({
        countries: soneCountryCodeList,
        searchText: country ? country.description : this.state.searchText,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const country = this.getCountries().find((country) => {
        return country.countryCode === `${this.props.value}`;
      });

      this.setState({
        searchText: country ? country.description : this.state.searchText,
      });
    }
  }

  getCountries = () => {
    return this.state.countries.filter((country) => {
      switch (this.props.allowedCountries) {
        case "AUS":
          return country.countryCode === CountryCode.Australia;
        case "OVERSEAS":
          return country.countryCode !== CountryCode.Australia;
        default:
          return true;
      }
    });
  };

  selectSuggestion = (event, inputText) => {
    this.setState({
      searchText: inputText,
    });
  };

  handleChange = (countryCode) => {
    return this.props.onChange(this.props.name, countryCode);
    
  }

  getCountryBySearchText = (searchText) =>
    getCountryByCountryCodeOrDescription(searchText, this.getCountries());

  inputChange = (event, country) => {
    return country
      ? this.handleChange(country.countryCode)
      : this.handleChange("");
  }
    

  handleClose = (event) => {
    if (this.state.searchText) {
      const country = this.getCountryBySearchText(this.state.searchText);
      if (country) {
        this.setState({
          searchText: country.description,
        });
      } else {
        const countries = findCountriesByDescription(
          this.state.searchText,
          this.getCountries(),
        );

        if (countries.length === 1) {
          this.setState({
            searchText: countries[0].description,
          });
          this.handleChange(countries[0].countryCode);
        }
      }
    }
  };

  render() {
    const filterOptions = createFilterOptions({
      matchFrom: "any",
      ignoreCase: true,
      stringify: (option) => option.description,
      limit: 5,
    });
    const countries = this.getCountries();

    return countries.length && (
      <Autocomplete
        options={countries}
        filterOptions={filterOptions}
        getOptionLabel={(option) =>
          typeof option === 'string'
            ? option
            : option?.description ?? ''
        }
        isOptionEqualToValue={(option, value) =>
          option?.countryCode === value?.countryCode
        }
        onClose={this.handleClose}
        onInputChange={this.selectSuggestion}
        onChange={this.inputChange}
        inputValue={this.state.searchText}
        value={this.props.value ? this.state.countries.find((country) => country.countryCode === this.props.value) : null}
        renderInput={(params) => {
          params.InputProps.endAdornment = undefined;
          params.inputProps.disabled =
            countries.length === 1 &&
            countries.some(
              (country) => country.countryCode === this.props.value,
            );
          return (
            <TextField
              {...params}
              error={this.props.errors}
              helperText={this.props.helperText}
              label="Country"
              variant="standard"
              fullWidth={true}
              margin="normal"
              sx={{ margin: 0 }}
            />
          );
        }}
      />
    );
  }
}
